var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"track-trace-results"},[(_vm.results && !_vm.loading)?_c('router-view'):_vm._e(),(!_vm.loading && !_vm.allSystemsReturned)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }